const ru = {
  title: `Страница не найдена`,
};

export default ru;
